import { nameErrors } from './plazaNames';
// QA starting values; product limits remain subject to the provider contract.
export const RADIUS_QA = { min: 50, max: 2000, step: 10, default: 300 };
export const CATEGORIES = ['baseball', 'meetup', 'dog', 'kpop', 'running'];
const EARTH_RADIUS_M = 6371008.8;
export function validCenter(latitude, longitude) {
  return latitude !== '' && longitude !== '' && Number.isFinite(Number(latitude)) && Number.isFinite(Number(longitude))
    && Math.abs(Number(latitude)) <= 85.05112878 && Math.abs(Number(longitude)) <= 180;
}
export function validateDraft(draft) {
  const errors = {};
  if (!draft.internal_name?.trim() || new Blob([draft.internal_name.trim()]).size > 160) errors.internal_name = 'nameError';
  if (Object.keys(nameErrors(draft.localized_names)).length) errors.localized_names = 'displayNameError';
  if (draft.visibility && (!['always', 'scheduled'].includes(draft.visibility) || (draft.category !== 'baseball' && draft.visibility !== 'always'))) errors.visibility = 'visibilityError';
  if (!CATEGORIES.includes(draft.category)) errors.category = 'categoryError';
  if (!validCenter(draft.latitude, draft.longitude)) errors.coordinates = 'coordinatesError';
  const radius = Number(draft.radius_m);
  if (draft.radius_m === '' || !Number.isFinite(radius) || radius < RADIUS_QA.min || radius > RADIUS_QA.max) errors.radius_m = 'radiusError';
  return errors;
}
export function radiusLabel(meters) {
  const value = Number(meters);
  if (!Number.isFinite(value)) return '—';
  return value < 1000 ? `${value} m` : `${Number((value / 1000).toFixed(2))} km`;
}
export function circleGeoJSON(latitude, longitude, radiusM, segments = 128) {
  if (!validCenter(latitude, longitude) || !(Number(radiusM) > 0)) return { type: 'FeatureCollection', features: [] };
  const lat = Number(latitude) * Math.PI / 180;
  const lon = Number(longitude) * Math.PI / 180;
  const distance = Number(radiusM) / EARTH_RADIUS_M;
  const coordinates = Array.from({ length: segments }, (_, index) => {
    const bearing = 2 * Math.PI * index / segments;
    const targetLat = Math.asin(Math.sin(lat) * Math.cos(distance) + Math.cos(lat) * Math.sin(distance) * Math.cos(bearing));
    const targetLon = lon + Math.atan2(Math.sin(bearing) * Math.sin(distance) * Math.cos(lat), Math.cos(distance) - Math.sin(lat) * Math.sin(targetLat));
    return [targetLon * 180 / Math.PI, targetLat * 180 / Math.PI];
  });
  coordinates.push([...coordinates[0]]);
  return { type: 'Feature', properties: {}, geometry: { type: 'Polygon', coordinates: [coordinates] } };
}
